<style scoped>
  .quit-single{
    position: relative;
    margin-bottom: 15px;
    border: 1px solid #add5ff;
    border-radius: 5px;
  }
  .quit-single h6{
    background: #d0e3f7;
    padding: 5px 10px;
  }
  .quit-single .content{
    padding: 10px;
  }
  .quit-single .steps{
    padding: 0 20px 0;
  }
</style>
<template>
  <content-layout :title="title" :headImage="headImage" :tabs="tabs" v-model="activeTab" :spin-show='spinShow'>
    <div class="icons" slot="icons">
      <!-- <button style="button" class="layout-icon">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-jiajianzujianjiahao"></use>
        </svg>
      </button> -->
    </div>
    <div slot="slogan"></div>
    <div class="activity-item mgui-container" slot="/apply/job">
      <div class="filter-row">
        <Button type="info" icon="md-arrow-down" :disabled="!$menu.isPower('jobdemand', 'export')" @click="exportJobs">导出当月数据</Button>
      </div>
      <div v-if="departments.length>0">
        <Row :gutter="16">
          <Col span="6">
            <Card v-for="(item, index) in departments" :key="index" style="margin-bottom:10px;" :style="selStyle(item.id)">
              <div @click="viewList(item.id)">
                <h4 style="margin-bottom:10px">{{item.name}}
                  <small style="color:#999;font-size:12px;" v-if="item.updated_at">(更新：{{item.updated_at | lastTime}})</small>
                  <small style="color:#999;font-size:12px;" v-else>(暂无需求)</small>
                </h4>
                <div style="float:right">
                  <Button :disabled="buttonDisabled(item.id)" size="small" icon="plus" @click="openModal(item.id)">新增需求</Button>
                  <!-- <Button type="info" size="small">查看</Button> -->
                </div>
                <div style="font-size:12px;color:#666">
                  <!-- <p>
                    员工：{{item.count}}
                  </p> -->
                  <p>
                    缺口：{{item.number||0}}
                    <!-- <a href="javascript:void(0)" style="border-bottom:1px solid #2d8cf0">查看</a>   -->
                  </p>
                </div>
              </div>
            </Card>
          </Col>
          <Col span="18">
            <Row :gutter="16" style="background: #f7f7f7;border-bottom:1px solid #eee;padding:5px 10px;margin-bottom:5px;">
              <Col span="4">职位名称</Col>
              <Col span="8">项目</Col>
              <Col span="4" style="text-align:center">人员数量</Col>
              <Col span="8" style="text-align:right">操作</Col>
            </Row>
            <Row :gutter="16" v-for="(item, ind) in lists" :key="ind" style="border-bottom:1px solid #eee;padding:5px 10px;margin-bottom:5px;">
              <Col span="4">
                <a href="javascript:void(0)" @click="view(item)" title="查看详情">{{item.title}} <Icon type="android-open" style="color:#999"></Icon></a>
              </Col>
              <Col span="8">
                <p>{{item.project}}</p>
                <Tag>工作地点：{{item.address||'--'}}</Tag>
              </Col>
              <Col span="4">
                <span style="display:block;text-align:center;border-left:1px solid #eee;border-right:1px solid #eee;">{{item.number}}</span>
              </Col>
              <Col span="8" style="text-align:right">
                <Button size="small" icon="md-refresh" @click="refresh(item)" :disabled="$store.state.userInfo.id != item.user_id">{{item.updated_at | lastTime}} 更新</Button>
                <Button size="small" icon="md-trash" type="error" @click="del(item.id)" :disabled="$store.state.userInfo.id != item.user_id">删除</Button>
              </Col>
            </Row>
            <div style="text-align: center;padding: 10px;color:#999" v-if="lists.length == 0">-- 暂无数据 --</div>
          </Col>
        </Row>
      </div>
      <Modal
        v-model="viewModal"
        title="详情"
        width="600px">
          <Form :label-width="80">
            <FormItem label="职位名称：">
              {{viewData.title}}
            </FormItem>
            <FormItem label="项目名称：">
              {{viewData.project}}
            </FormItem>
            <FormItem label="资格认证：">
              {{viewData.certificate}}
            </FormItem>
            <FormItem label="人员要求：">
              {{viewData.demand}}
            </FormItem>
            <FormItem label="工作经验：">
              {{viewData.year}} <span>年</span>
            </FormItem>
            <FormItem label="工作地点：">
              {{viewData.address}}
            </FormItem>
            <FormItem label="数量：">
              {{viewData.number}}
            </FormItem>
            <FormItem label="详细需求：">
              {{viewData.content}}
            </FormItem>
          </Form>
      </Modal>
      <Modal
          v-model="updateModel"
          title="发布需求"
          width="600px">
            <Form ref="formItem" :model="formItem" label-position="right" :label-width="85" :rules="ruleData" class="costs-form">
              <FormItem label="职位名称：" prop="title">
                <Input v-model="formItem.title" style="width:280px;"></Input>
              </FormItem>
              <FormItem label="项目名称：" prop="project" style="display:inline-block;position: relative;z-index: 10">
                <Input v-model="formItem.project" :readonly="true" style="width:280px;" placeholder="请选择项目">
                <Poptip placement="bottom" width="280" slot="append">
                  <a href="javascript:void(0)" @click="getProject" ref="poptipProject">选择</a>
                  <div class="api" slot="content" style="text-align:left">
                    <RadioGroup v-model="curProject">
                      <p v-for="item in projects" :key="item.value" style="padding: 5px 0" @click.stop="radioChange(item)">
                        <Radio :label="item.label">{{item.label}}</Radio>
                      </p>
                    </RadioGroup>
                  </div>
                </Poptip>
                </Input>
              </FormItem>
              <FormItem label="资格认证：" prop="certificate">
                <RadioGroup v-model="formItem.certificate">
                  <Radio :label="'不需要'">不需要</Radio>
                  <Radio :label="'初级'">初级</Radio>
                  <Radio :label="'中级'">中级</Radio>
                  <Radio :label="'高级'">高级</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="人员要求：">
                <RadioGroup v-model="formItem.demand">
                  <Radio :label="'有经验'">有经验</Radio>
                  <Radio :label="'实习生'">实习生</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="工作经验：" v-show="formItem.demand != '实习生'" prop="year">
                <Input v-model="formItem.year" style="width:280px">
                  <span slot="append">年</span>
                </Input>
              </FormItem>
              <FormItem label="工作地点：" prop="address">
                <Input v-model="formItem.address" style="width:0;height:0;padding:0;overflow: hidden"></Input>
                <city-select v-model="address"></city-select>
              </FormItem>
              <FormItem label="数量：" prop="number">
                <InputNumber v-model="formItem.number" style="text-align: center;width:160px" number>
                </InputNumber>
              </FormItem>
              <FormItem label="详细需求：" prop="content" style="position: relative;">
                <Input v-model="formItem.content" type="textarea" style="min-height: 80px" :autosize="{minRows: 6}"></Input>
                <div style="position:absolute;bottom:-20px;right:0;color:#999;padding:5px;line-height: 14px;text-align:right">{{formItem.content.length + '/50'}}</div>
              </FormItem>
          </Form>
          <footer slot="footer">
            <Tag style="float:left">招聘有效截止日期。自提交日起一个月</Tag>
            <Button @click="updateModel=false">关闭</Button>
            <Button type="success" @click="submitProject">提交</Button>
          </footer>
      </Modal>
    </div>
    <!-- <div class="activity-item mgui-container" slot="/users/post" style="padding-bottom:100px"> -->
    <!-- </div> -->
  </content-layout>
</template>

<script>
  import {formatDate} from '../util/filter'
  import {fetch, put, post, del} from '../fetch/api'

  const formData = {
    demand: '有经验',
    certificate: '不需要',
    department_id: '',
    project_id: '',
    title: '',
    project: '',
    number: 0,
    address: '',
    content: ''
  }

  export default {
    name: 'Apply',
    components: {
      ContentLayout: resolve => { require(['../components/ContentLayoutComponent'], resolve) },
      CitySelect: resolve => { require(['../components/CitySelectComponent'], resolve) },
      // UserEditForm: resolve => { require(['../components/UserEditFormComponent'], resolve) }
    },
    data () {
      let token = localStorage.getItem('token')
      const validateNumber = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请输入数量'))
        }
        // 模拟异步验证效果
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数量'))
        } else {
          callback()
        }
      }

      const validateContent = (rule, value, callback) => {
        if (value.length < 50) {
          return callback(new Error('请输入详细描述，描述必须大于50字符！'))
        } else {
          callback()
        }
      }
      const validateYear = (rule, value, callback) => {
        if (this.formItem.demand === '有经验' && !value) {
          return callback(new Error('请输入工作年限'))
        } else {
          callback()
        }
      }

      return {
        title: '人才需求',
        tabs: [
          {'title': '部门', 'key': '/apply/job', 'visible': true}
        ],
        activeTab: '/apply/job',
        headImage: '/static/images/bg/money.jpeg',
        spinShow: true,
        isDisabled: false,
        departments: [],
        viewModal: false,
        exportTime: [],
        token: token,
        editItems: [],
        quitCount: {},
        filterItem: {
          status: 0,
          state: 0
        },
        lists: [],
        updateNumber: 0,
        viewData: {},
        currentDid: 0,
        projects: [],
        curProject: '',
        selItemId: 0,
        updateModel: false,
        project_id: '',
        formItem: JSON.parse(JSON.stringify(formData)),
        currentId: 0,
        checkModal: false,
        checkModalLoading: true,
        checkForm: {},
        steps: [],
        address: [],
        ruleData: {
          project: [
            {required: true, message: '请选择项目', trigger: 'change'}
          ],
          address: [
            {required: true, message: '请选择工作地点', trigger: 'change'}
          ],
          title: [
            {required: true, message: '请输入职位', trigger: 'change'}
          ],
          year: [
            { validator: validateYear, trigger: 'blur' }
          ],
          content: [
            {required: true, message: '请输入职位描述', trigger: 'change'},
            { validator: validateContent, trigger: 'blur' }
          ],
          number: [
            { validator: validateNumber, trigger: 'blur' }
          ]
        },
        leaveCollapse: null,
        page: {
          total: 0,
          page: 1
        }
      }
    },
    watch: {
      $route (to) {
        this.routeChange(to)
      },
      address (val) {
        this.$set(this.formItem, 'address', val.join(','))
      }
    },
    mounted () {
      let action = this.$route.params.action
      if (action) this.leaveCollapse = action + '_' + 0
      this.fetchData()
      this.routeChange(this.$route)
      this.$store.dispatch('setDepartment', false)
    },
    filters: {
      lastTime (time) {
        return formatDate(time)
      }
    },
    methods: {
      exportJobs () {
        fetch('console/exportJobs/month').then(res => {
          if (res.status === 'ok') {
            window.location.href = this.apiPath + `export/jobs?cry=${res.cry}`
          }
        })
      },
      refresh (item) {
        this.$Modal.confirm({
          title: '更新数量',
          render: (h) => {
            return h('InputNumber', {
              style: {
                width: '100%',
                marginTop: '20px'
              },
              props: {
                value: item.number,
                autofocus: true,
                placeholder: '请输入数量'
              },
              on: {
                input: (val) => {
                  this.updateNumber = val
                  // console.log('val', val)
                }
              }
            })
          },
          onOk: () => {
            // console.log('val', this.updateNumber)
            put(`console/jobNumber/${item.id}`, {'number': this.updateNumber}).then(res => {
              if (res.status === 'ok') {
                item.number = this.updateNumber
                item.updated_at = res.updated_at.date
                this.$Message.info(res.msg)
              }
            })
          }
        })
      },
      projectInputClick () {
        this.$refs.poptipProject.click()
      },
      selStyle (id) {
        return {
          backgroundColor: id === this.currentDid ? '#fff6db' : '',
          borderColor: id === this.currentDid ? '#f3cf67' : ''
        }
      },
      radioChange (item) {
        this.selItemId = item.value
        this.formItem.project = item.label
        this.formItem.project_id = item.value
      },
      viewList (id) {
        // this.listsModal = true
        this.currentDid = id
        this.fetchJobs()
      },
      openModal (id) {
        this.formItem.department_id = id
        this.currentDid = id
        this.updateModel = true
      },
      buttonDisabled (did) {
        // let role = this.$store.state.userInfo.role
        // let groupid = this.$store.state.userInfo.group_id
        let dids = JSON.parse(this.$store.state.userInfo.department_id)
        return dids.indexOf(did) < 0
      },
      handleChange (val, selectedData) {
        this.$set(this.formItem, 'project', '')
        this.$set(this, 'project_id', '')
        if (selectedData[1]) {
          this.$set(this.formItem, 'project', selectedData[1].label)
          this.$set(this, 'project_id', selectedData[1].value)
        }
      },
      del (id) {
        this.$Modal.confirm({
          title: '删除确认',
          content: '确定删除该职位？',
          onOk: () => {
            del(`console/jobDemand/${id}`).then(res => {
              if (res.status === 'ok') {
                this.$Message.info('删除成功')
                this.fetchJobs()
              }
            })
          }
        })
      },
      view (item) {
        this.viewModal = true
        this.viewData = item
      },
      pagerChange (val) {
        this.page.page = val
        this.fetchData()
      },
      getProject () {
        for (let k in this.$store.state.department) {
          if (this.$store.state.department[k].value === this.currentDid) {
            this.projects = this.$store.state.department[k].children
          }
        }
      },
      fetchJobs () {
        let did = this.currentDid
        fetch(`console/jobs/${did}`).then(res => {
          if (res.status === 'ok') {
            this.lists = res.result
          }
        }).catch(() => {
        })
      },
      submitProject () {
        this.$refs['formItem'].validate((valid) => {
          if (valid) {
            let data = JSON.parse(JSON.stringify(this.formItem))
            post(`console/jobDemand`, data).then(res => {
              if (res.status === 'ok') {
                this.formItem = JSON.parse(JSON.stringify(formData))
                this.updateModel = false
                this.fetchJobs()
              }
            })
          }
        })
      },
      fetchData () {
        let params = this.filterItem
        params.page = this.page.page
        this.spinShow = true
        fetch(`console/departments/all`, {params: params}).then(res => {
          if (res.status === 'ok') {
            this.page.total = res.result.total
            this.departments = res.result
            if (this.departments.length > 0) {
              this.currentDid = this.departments[0].id
              this.fetchJobs()
            }
          }
          this.spinShow = false
        }).catch(() => {
          this.spinShow = false
        })
      },
      routeChange (route) {
        let action = route.params.action
        if (action === undefined) {
          this.activeTab = '/apply/job'
          // this.fetchData()
          this.spinShow = false
        }
        if (action === 'post') {
          this.activeTab = '/apply/job/post'
          this.spinShow = false
        }
      },
      formatPath (path) {
        return `${this.apiPath}api/console/pdf?type=downpdf&path=${path}&name=浙江宇脉-离职手续单&token=${this.token}`
      },
      read (item) {
        if (item.status === 0) {
          item.status = 1
          put(`console/applyStatus/${item.id}?status=${item.status}`)
        }
      }
    }
  }
</script>

<style>
  .users-count{
    position: absolute;
    right: 10px;
    bottom: 10px;
    z-index: 2;
    border: 1px solid #eee;
    border-radius: 4px;
    /*background: #f7f7f7;*/
    color: #fff;
    padding: 5px 10px;
  }
  .filter-row-item{display: inline-block;}
  .users-count span,.users-count a{
    margin-right: 10px
  }
  .users-count a{color:#fff;text-decoration: underline}
  .collapse-active .ivu-collapse-content{display: block !important}
  .collapse-active .ivu-collapse-header{background: #ffeccf}
  @media (max-width: 640px) {
    .filter-row-item{display: block;margin-bottom: 10px}
    .users-count{width:200px;}
  }
</style>
